module.exports = __webpack_public_path__ + "static/media/zheng2-4@2x.b86ce1e4.png";